export const FEATURE_FLAGS = {
  EDIT_LINK_TO_DOCUMENT: 'edit-link-to-document',
  PERMISSIONS_HANDLING: 'permissions-handling',
  REPORT_SYNC_TIMEOUT_SECONDS: 'report-sync-timeout-seconds',
  RFIS_SEARCH: 'rfis-search',
  RFIS_NEW_VIEWER_EVENTS: 'rfis-new-viewer-events',
  RFIS_CUSTOM_ROLES: 'rfis-custom-roles',
  RFIS_REDUX_DEVTOOLS: 'rfis-redux-devtools',
  RFIS_LINK_TO_PCO: 'rfis-link-to-pco',
  RFIS_SIB: 'rfis-sib',
  RFIS_REOPEN: 'rfis-reopen',
  RFIS_REFERENCED_BY: 'rfis-referenced-by',
  RFIS_FETCH_ALL_DOCUMENTS_BATCHES: 'rfi-fetch-all-documents-batches',
  RFIS_USE_THE_RFI_VIRTUAL_FOLDER_URN: 'rfis-bim-use-rfi-virtual-folder-urn',
  MAINTENANCE_MODE: 'bim-rfis-maintenance-mode',
};

export const DEFAULT_FEATURE_FLAGS_VALUES = {
  [FEATURE_FLAGS.EDIT_LINK_TO_DOCUMENT]: true,
  [FEATURE_FLAGS.PERMISSIONS_HANDLING]: false,
  [FEATURE_FLAGS.REPORT_SYNC_TIMEOUT_SECONDS]: 60,
  [FEATURE_FLAGS.RFIS_SEARCH]: true,
  [FEATURE_FLAGS.RFIS_NEW_VIEWER_EVENTS]: false,
  [FEATURE_FLAGS.RFIS_CUSTOM_ROLES]: true,
  [FEATURE_FLAGS.RFIS_REDUX_DEVTOOLS]: false,
  [FEATURE_FLAGS.RFIS_LINK_TO_PCO]: true,
  [FEATURE_FLAGS.RFIS_SIB]: true,
  [FEATURE_FLAGS.RFIS_REOPEN]: true,
  [FEATURE_FLAGS.RFIS_REFERENCED_BY]: true,
  [FEATURE_FLAGS.RFIS_FETCH_ALL_DOCUMENTS_BATCHES]: true,
  [FEATURE_FLAGS.RFIS_USE_THE_RFI_VIRTUAL_FOLDER_URN]: true,
  [FEATURE_FLAGS.MAINTENANCE_MODE]: 'OFF',
};
